"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _materialSymbols = require("@design/icons/material-symbols");
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _chatMarkdownPipeline = require("@common/markdown/chatMarkdownPipeline");
var _OoxmlContent = _interopRequireDefault(require("@common/components/remedy/OoxmlContent"));
var _compare = require("../../utils/compare");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children"],
  _excluded2 = ["children"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var CitationContainer = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-top: 8px;\n  border-top: 1px solid #e2e8f0;\n  padding-top: 8px;\n"])));
var CitationHeader = _styledComponents.default.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #6b7280;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 4px 0;\n  transition: color 0.2s;\n\n  &:hover {\n    color: #4a5568;\n  }\n"])));
var CitationCount = _styledComponents.default.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-color: var(--primary);\n  color: white;\n  border-radius: 12px;\n  padding: 2px 6px;\n  font-size: 10px;\n  font-weight: 600;\n  min-width: 16px;\n  text-align: center;\n"])));
var CitationList = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  max-height: ", ";\n  overflow: hidden;\n  transition: max-height 0.3s ease;\n  margin-top: ", ";\n"])), function (props) {
  return props.isExpanded ? 'none' : '0';
}, function (props) {
  return props.isExpanded ? '8px' : '0';
});
var CitationItem = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-bottom: 12px;\n  padding: 8px 12px;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n  border-left: 3px solid var(--primary);\n"])));
var CitationHeaderItem = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n"])));
var CitationNumber = _styledComponents.default.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  background-color: var(--primary);\n  color: white;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 600;\n"])));
var DocumentTitle = _styledComponents.default.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 600;\n  color: #4a5568;\n"])));
var CitationContent = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  line-height: 1.4;\n  color: #374151;\n\n  & p {\n    margin: 0 0 8px 0;\n  }\n\n  & p:last-child {\n    margin-bottom: 0;\n  }\n\n  & div {\n    margin-bottom: 4px;\n  }\n\n  & div:last-child {\n    margin-bottom: 0;\n  }\n"])));
var CitationListComponentInner = function CitationListComponentInner(_ref) {
  var citations = _ref.citations;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  if (!citations || citations.length === 0) {
    return null;
  }
  var handleToggle = function handleToggle() {
    setIsExpanded(!isExpanded);
  };
  var renderCitedContent = function renderCitedContent(citedText) {
    // `<w:` markers indicate OOXML tracked-change content (w:ins, w:del, etc.)
    if (citedText.includes('<w:') || citedText.includes('&lt;w:')) {
      var decodedText = citedText.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&').replace(/&#8220;/g, '"').replace(/&#8221;/g, '"').replace(/&#8217;/g, "'").replace(/&#8216;/g, "'");
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_OoxmlContent.default, {
        ooxml: decodedText,
        style: {
          fontSize: '13px',
          lineHeight: '1.4'
        }
      });
    }
    if (citedText.includes('<ins') || citedText.includes('<del') || citedText.includes('&lt;ins') || citedText.includes('&lt;del')) {
      var _decodedText = citedText.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&').replace(/&#8220;/g, '"').replace(/&#8221;/g, '"').replace(/&#8217;/g, "'").replace(/&#8216;/g, "'");
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactMarkdown.default, {
        components: {
          p: function p(_ref2) {
            var children = _ref2.children;
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              style: {
                margin: '0 0 8px 0'
              },
              children: children
            });
          },
          strong: function strong(_ref3) {
            var children = _ref3.children;
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
              style: {
                fontWeight: '600'
              },
              children: children
            });
          },
          em: function em(_ref4) {
            var children = _ref4.children;
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("em", {
              style: {
                fontStyle: 'italic'
              },
              children: children
            });
          },
          ins: function ins(_ref5) {
            var children = _ref5.children,
              props = _objectWithoutProperties(_ref5, _excluded);
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                textDecoration: 'underline',
                color: '#F49E80',
                cursor: 'help'
              },
              title: "Author: ".concat(props.author || 'Unknown', ", Date: ").concat(props.date || 'Unknown'),
              children: children
            });
          },
          del: function del(_ref6) {
            var children = _ref6.children,
              props = _objectWithoutProperties(_ref6, _excluded2);
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              style: {
                textDecoration: 'line-through',
                color: '#F49E80',
                cursor: 'help'
              },
              title: "Author: ".concat(props.author || 'Unknown', ", Date: ").concat(props.date || 'Unknown'),
              children: children
            });
          }
        },
        rehypePlugins: _chatMarkdownPipeline.chatRehypePlugins,
        remarkPlugins: _chatMarkdownPipeline.artifactBodyRemarkPlugins,
        children: _decodedText
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactMarkdown.default, {
      components: {
        p: function p(_ref7) {
          var children = _ref7.children;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            style: {
              margin: '0 0 8px 0'
            },
            children: children
          });
        },
        strong: function strong(_ref8) {
          var children = _ref8.children;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
            style: {
              fontWeight: '600'
            },
            children: children
          });
        },
        em: function em(_ref9) {
          var children = _ref9.children;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("em", {
            style: {
              fontStyle: 'italic'
            },
            children: children
          });
        }
      },
      rehypePlugins: _chatMarkdownPipeline.chatRehypePlugins,
      remarkPlugins: _chatMarkdownPipeline.artifactBodyRemarkPlugins,
      "data-sentry-element": "Markdown",
      "data-sentry-component": "renderCitedContent",
      "data-sentry-source-file": "CitationList.tsx",
      children: citedText
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(CitationContainer, {
    "data-sentry-element": "CitationContainer",
    "data-sentry-component": "CitationListComponentInner",
    "data-sentry-source-file": "CitationList.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(CitationHeader, {
      onClick: handleToggle,
      "data-sentry-element": "CitationHeader",
      "data-sentry-source-file": "CitationList.tsx",
      children: [isExpanded ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.KeyboardArrowDownIcon, {
        width: 14,
        height: 14
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronRightIcon, {
        width: 14,
        height: 14
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: "Citations"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CitationCount, {
        "data-sentry-element": "CitationCount",
        "data-sentry-source-file": "CitationList.tsx",
        children: citations.length
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CitationList, {
      isExpanded: isExpanded,
      "data-sentry-element": "CitationList",
      "data-sentry-source-file": "CitationList.tsx",
      children: citations.map(function (citation, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(CitationItem, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(CitationHeaderItem, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(CitationNumber, {
              children: citation.number || index + 1
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(DocumentTitle, {
              children: citation.document_title || 'Document'
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CitationContent, {
            children: citation.cited_text && renderCitedContent(citation.cited_text)
          })]
        }, citation.id || index);
      })
    })]
  });
};
var areCitationListPropsEqual = function areCitationListPropsEqual(prevProps, nextProps) {
  if (prevProps.citations.length !== nextProps.citations.length) {
    return false;
  }
  for (var i = 0; i < prevProps.citations.length; i++) {
    var prevCitation = prevProps.citations[i];
    var nextCitation = nextProps.citations[i];
    if (prevCitation.id !== nextCitation.id || prevCitation.number !== nextCitation.number || prevCitation.document_title !== nextCitation.document_title || prevCitation.cited_text !== nextCitation.cited_text || prevCitation.bookmark_start !== nextCitation.bookmark_start || prevCitation.bookmark_end !== nextCitation.bookmark_end || prevCitation.messageIndex !== nextCitation.messageIndex) {
      return false;
    }
    if (!(0, _compare.areArraysEqual)(prevCitation.bookmarks, nextCitation.bookmarks)) {
      return false;
    }
  }
  return true;
};
var CitationListComponent = /*#__PURE__*/_react.default.memo(CitationListComponentInner, areCitationListPropsEqual);
var _default = exports.default = CitationListComponent;